<div class="changeControlAuditSection" *ngIf="!showLoader">
  <app-change-control-life-cycle
    *ngIf="ischangeControlAuditDetailsDataLoaded"
    [auditLifecycleInput]="changeControlLifeCycleDetails"
  ></app-change-control-life-cycle>

  <p-fieldset
    legend="Audit Trail"
    *ngIf="ischangeControlAuditDetailsDataLoaded"
  >
    <div class="grid">
      <div class="col-6">
        <app-change-control-audit-summary
          [auditSummaryDetails]="changeControlAuditSummaryDetails"
          (attributeDetailsOfTransaction)="showAuditItemDetails($event)"
        ></app-change-control-audit-summary>
      </div>
      <div class="col-6 auditTrialDetailsSection">
        <app-audit-item-details
          [auditTrialDetails]="auditAttributeDetailsOfTransaction"
        ></app-audit-item-details>
      </div>
    </div>
  </p-fieldset>
</div>
